import "./App.css";
import S1_Header from "./pages/MainPage/S1_Header";
import S2_Features from "./pages/MainPage/S2_Features/Index";
import S3_Tokenomics from "./pages/MainPage/S3_Tokenomics";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <div>
        <Routes>
          <Route exact path="/" element={<S1_Header />} />
          <Route exact path="/features" element={<S2_Features />} />
          <Route exact path="/tokenomics" element={<S3_Tokenomics />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
